import { render } from "./ListPublicationPage.vue?vue&type=template&id=6bf59d3c&ts=true"
import script from "./ListPublicationPage.vue?vue&type=script&lang=ts"
export * from "./ListPublicationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__